import s from "./ui.module.css";

/** Ladeanzeige (BAUPLAN-PAKETE.md, Abschnitt 5.5). role="status": Screenreader sagen sie an, ohne den Fokus zu nehmen. */
export function Laedt({ text = "Lädt …" }: { text?: string }) {
  return (
    <p className={s.laedt} role="status">
      <span className={s.laedtKreis} aria-hidden="true" />
      {text}
    </p>
  );
}
